module.exports = __webpack_public_path__ + "img/bearhouse_how_to_pay.d95b49a0.jpg";